/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flow_Purchase_4Inputs */

const en_flow_purchase_4 = /** @type {(inputs: Flow_Purchase_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available stock comes back from the IMS.`)
};

/**
* | output |
* | --- |
* | "Available stock comes back from the IMS." |
*
* @param {Flow_Purchase_4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const flow_purchase_4 = /** @type {((inputs?: Flow_Purchase_4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flow_Purchase_4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_flow_purchase_4(inputs)
});